import React, { useEffect, useState } from "react";
import "./ReviewInvoiceView.css";
import ReviewInvoiceForm from "../ReviewForm/ReviewInvoiceForm";
import { useSelector, useDispatch } from "react-redux";
import { resetSelectedInvoiceData, setSelectedInvoiceData } from "../../../../Reducer/SelectedInvoiceDataReducer";
import Loader from "../../../../Components/Loader/Loader";
import { InvoiceDocumentViewer } from "../../../../Components/DocumentViewer/InvoiceDocumentViewer";
import {
  DeleteInvoice,
  GetInvoiceService,
  GetInvoicesService_NEW,
  UnmergeInvoiceService,
} from "../../../../Services/InvoiceService/InvoiceService";
import CancelBtn from "../../../../Components/CustomButtons/CancelBtn/CancelBtn";
import ConfirmPopup from "../../../../Components/ConfirmPopup/ConfirmPopup";
import AlertMessage from "../../../../Components/AlertMessage/AlertMessage";
import { Tooltip } from "../../../../Components/CommonUI/tooltip";
import { InvoiceType } from "../../../../Types/Invoice";
import { MdDelete } from "react-icons/md";
import { setSelectedInvoice } from "../../../../Reducer/SelectedInvoiceReducer";
import { useInvoiceActions } from "../../../../hooks/useInvoiceActions";
import InvoiceForm from "../../3Inbox/InvoiceForm/InvoiceForm";
import { MdCallSplit } from "react-icons/md";




interface InvoiceViewProps {
  setInvoiceView: React.Dispatch<React.SetStateAction<boolean>>;
  refreshInvoices?: any;
  sortSettings?: any;
  fullinvoices?: any[];
  totalInvoiceCount?: number;
}

const ReviewInvoiceView: React.FC<InvoiceViewProps> = ({
  setInvoiceView,
  refreshInvoices,
  sortSettings,
  fullinvoices,
  totalInvoiceCount,
}) => {
  const { makeInvoiceViewed, getInvoicesInbox } = useInvoiceActions();
  const dispatch = useDispatch();
  const [openPopup, setOpenPopup] = useState(false);
  const [invoiceDataSource, setInvoiceDataSource] = useState<InvoiceType[]>([]);
  const [loaderStatus, setLoaderStatus] = useState(false);
  const [allInvoices, setAllInvoices] = useState<any[]>([]);
  const [currentInvoiceIndex, setCurrentInvoiceIndex] = useState(0);
  const [unmergeLoading, setUnmergeLoading] = useState(false);
  const [showUnmergeConfirm, setShowUnmergeConfirm] = useState(false);

  // Fetch selected invoice from Redux store
  const selectedInvoice = useSelector((state: any) => state.selectedInvoice);
  const selectedClient = useSelector((state: any) => state.selectedClient);
  const [hover, setHover] = useState(false);
  const savedSort = localStorage.getItem("sortSettings");

  const FetchData = async () => {
    // Destructure selectedInvoice for clarity
    const invoiceId = selectedInvoice?.selectedInvoice?.id;

    // Early exit if no valid invoice ID is found
    if (!invoiceId) {
      console.error("No valid invoice ID found in selectedInvoice");
      return;
    }

    try {
      // Fetch invoice data by ID
      const result = await GetInvoiceService(invoiceId);

      if (result) {
        setInvoiceDataSource([result]); //result

        UpdateSelectedInvoiceData(result);
      } else {
        console.warn(`No data found for invoice ID: ${invoiceId}`);
      }
    } catch (error) {
      // Log error details and provide context
      console.error(`Failed to fetch invoice data for ID: ${invoiceId}`, error);
    }
  };

  const UpdateSelectedInvoiceData = (result: any) => {
    // Update the selected invoice data in Redux store
    dispatch(setSelectedInvoiceData(result));
  };
  const handleDelete = async () => {
    const invoiceId = selectedInvoice.selectedInvoice.id;
    if (!invoiceId) return;

    try {
      await DeleteInvoice(invoiceId);
      setOpenPopup(false);
      setInvoiceView(false);
      AlertMessage({ text: "Invoice deleted successfully", type: "success" });
    } catch (error: any) {
      AlertMessage({
        text: error.message || "Failed to delete invoice",
        type: "error",
      });
    } finally {
      refreshInvoices();
    }
  };

  // ─── Step 1: User clicks Unmerge button ──────────────────────────────────
const handleUnmergeClick = () => {
  setShowUnmergeConfirm(true);
};

// ─── Step 2: User clicks Cancel in confirm popup ──────────────────────────
const handleUnmergeCancel = () => {
  setShowUnmergeConfirm(false);
};

// ─── Step 3: User clicks Proceed/Confirm in confirm popup ─────────────────
const handleUnmergeConfirm = async () => {
  const invoiceId = invoiceDataSource[0]?.invoiceId;
  if (!invoiceId) return;

  setShowUnmergeConfirm(false);
  setUnmergeLoading(true);

  try {
    const result = await UnmergeInvoiceService({
      mergedInvoiceId: invoiceId,
    });

    AlertMessage({
      text: `Invoice unmerged. ${result.restoredInvoiceIds.length} invoice(s) restored.`,
      type: "success",
    });

    setInvoiceView(false);
    dispatch(resetSelectedInvoiceData()); // make sure this import exists, see note below
    setTimeout(() => {
      refreshInvoices?.();
    }, 100);
  } catch (error: any) {
    AlertMessage({
      text: error?.message ?? "Failed to unmerge invoice",
      type: "error",
    });
  } finally {
    setUnmergeLoading(false);
  }
};
  const loadFullInvoice = async (id: any) => {
    if (!id) return;
    setLoaderStatus(true);
    try {
      const fullInvoice = await GetInvoiceService(id);
      if (fullInvoice) {
        setInvoiceDataSource([fullInvoice]);
        dispatch(setSelectedInvoiceData(fullInvoice));

        makeInvoiceViewed(fullInvoice.invoiceId, fullInvoice.stageId);
      }
    } catch (error) {
      console.error("Error loading invoice:", error);
    } finally {
      setLoaderStatus(false);
    }
  };

  const handleRefreshInvoice = async () => {
    const invoiceId = selectedInvoice?.selectedInvoice?.id;
    if (!invoiceId) return;

    try {
      refreshInvoices();
      await loadFullInvoice(invoiceId);
    } catch (error) {
      console.error("Error refreshing invoice:", error);
    }
  };
  const handleNextInvoice = async () => {
    if (currentInvoiceIndex < allInvoices.length - 1) {
      const nextIndex = currentInvoiceIndex + 1;

      setLoaderStatus(true);
      setCurrentInvoiceIndex(nextIndex);
      const nextInvoice = allInvoices[nextIndex];
      await loadFullInvoice(nextInvoice.id);

      try {
         const fullInvoice = await GetInvoiceService(nextInvoice.id);
        if (fullInvoice) {
          setInvoiceDataSource([fullInvoice]);
          dispatch(setSelectedInvoiceData(fullInvoice));

          // makeInvoiceViewed(fullInvoice.invoiceId, fullInvoice.stageId);
        }
      } catch (error) {
        console.error("Error loading invoice:", error);
      } finally {
        setLoaderStatus(false);
      }
      dispatch(setSelectedInvoice(nextInvoice));
    }
  };
  const handlePreviousInvoice = async () => {
    if (currentInvoiceIndex > 0) {
      const prevIndex = currentInvoiceIndex - 1;

      setLoaderStatus(true);
      setCurrentInvoiceIndex(prevIndex);
      const prevInvoice = allInvoices[prevIndex];

      await loadFullInvoice(prevInvoice.id);
      try {
        const fullInvoice = await GetInvoiceService(prevInvoice.id);
        if (fullInvoice) {
          setInvoiceDataSource([fullInvoice]);
          dispatch(setSelectedInvoiceData(fullInvoice));

          makeInvoiceViewed(fullInvoice.invoiceId, fullInvoice.stageId);
        }
      } catch (error) {
        console.error("Error loading invoice:", error);
      } finally {
        setLoaderStatus(false);
      }
    }
  };

  //Todo Fetch the redux state for current selected invoice and send it to service ot fetch the invoice details
  useEffect(() => {
    const invoices = fullinvoices ?? [];
    setAllInvoices(invoices);

    const currentId = selectedInvoice?.selectedInvoice?.id;
    const index = invoices.findIndex((inv: any) => inv.id === currentId);

    if (index !== -1) {
      setCurrentInvoiceIndex(index);
    } else {
      setCurrentInvoiceIndex(0); // fallback
    }

    loadFullInvoice(currentId);
  }, []);

  // Keyboard navigation for Next (Ctrl + K) and Previous (Ctrl + J)
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Avoid triggering inside input/textarea fields
      const target = event.target as HTMLElement;
      const isTyping =
        target.tagName === "INPUT" ||
        target.tagName === "TEXTAREA" ||
        target.isContentEditable;

      if (isTyping) return;

      // Ctrl + K → Next
      if (event.ctrlKey && event.key.toLowerCase() === "k") {
        event.preventDefault();
        if (currentInvoiceIndex < allInvoices.length - 1) {
          handleNextInvoice();
        }
      }

      // Ctrl + J → Previous
      if (event.ctrlKey && event.key.toLowerCase() === "j") {
        event.preventDefault();
        if (currentInvoiceIndex > 0) {
          handlePreviousInvoice();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [currentInvoiceIndex, allInvoices]);
  const handleclose = () => {
    setInvoiceView(false);
    refreshInvoices();
  };

  const isMergedInvoice = invoiceDataSource[0]?.mergeStatus === "Merged";

  // Don't need this second useEffect anymore - FetchAllInvoices handles the full data fetch
  // The data will be loaded when component mounts and when navigating with Next/Previous buttons
  return (
    <div className="invoiceView">
      <div className="invoiceView-header">
        {isMergedInvoice && (
  <div style={{ marginRight: "20px" }}>
            <Tooltip title="Unmerge back into original invoices" description="">
              <button
                onClick={handleUnmergeClick}
                disabled={unmergeLoading}
                style={{
                  backgroundColor: unmergeLoading ? "#ccc" : "var(--color-brand)",
                  color: "#fff",
                  border: "none",
                  padding: "6px 14px",
                  borderRadius: "6px",
                  cursor: unmergeLoading ? "not-allowed" : "pointer",
                  fontSize: "13px",
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <MdCallSplit size={16} />
                {unmergeLoading ? "Unmerging..." : "Unmerge"}
              </button>
            </Tooltip>
          </div>
        )}
        <div className="invoiceView-header-pagination">
          Invoice View ({currentInvoiceIndex + 1} of {totalInvoiceCount})
        </div>
        <div style={{ display: "flex", gap: "10px", marginRight: "10px" }}>
          <Tooltip title="Previous" description="shortcut: ctrl + j">
            <button
              disabled={currentInvoiceIndex === 0}
              style={{
                backgroundColor:
                  currentInvoiceIndex === 0 ? "#cccccc" : "var(--color-brand)",
                color: "#ffffff",
                padding: "4px 8px",
                borderRadius: "4px",
                border: "none",
                cursor: currentInvoiceIndex === 0 ? "not-allowed" : "pointer",
              }}
              onClick={handlePreviousInvoice}
            >
              Previous
            </button>
          </Tooltip>
          <Tooltip title="Next" description="shortcut: ctrl + k">
            <button
              disabled={currentInvoiceIndex === allInvoices.length - 1}
              style={{
                backgroundColor:
                  currentInvoiceIndex === allInvoices.length - 1
                    ? "#cccccc"
                    : "var(--color-brand)",
                color: "#ffffff",
                padding: "4px 8px",
                borderRadius: "4px",
                border: "none",
                width: "70px",
                cursor:
                  currentInvoiceIndex === allInvoices.length - 1
                    ? "not-allowed"
                    : "pointer",
              }}
              onClick={handleNextInvoice}
            >
              Next
            </button>
          </Tooltip>
        </div>
        {/* <div style={{ marginRight: "20px" }}>
          {" "}
          <button
            style={{
              backgroundColor: "#db0720ff",
              color: "#ffffff",
              padding: "4px",
              borderRadius: "2px",
              border: "none",
            }}
            onClick={() => setOpenPopup(true)}
          >
            Delete Invoice
          </button>
        </div> */}
        <div className="invoiceView-header-close" onClick={() => handleclose()}>
          <Tooltip title="Close Invoice View" description="">
            <CancelBtn style={{ color: hover ? "red" : "darkred" }} />
          </Tooltip>
        </div>
      </div>
      <div className="invoiceView-body">
        {loaderStatus ? (
          <div className="invoiceView-loader">
            <Loader />
          </div>
        ) : (
          <>
            <div className="invoiceView-body-left">
              <InvoiceDocumentViewer />
            </div>
            <div className="invoiceView-body-right">
              {loaderStatus ? (
                <Loader />
              ) : (
                <InvoiceForm
                  setInvoiceView={setInvoiceView}
                  invoiceDataSource={invoiceDataSource}
                  //setLoaderStatus={setLoaderStatus}
                  handleNextInvoice={handleNextInvoice}
                  isLastInvoice={currentInvoiceIndex === allInvoices.length - 1}
                  refreshInvoices={handleRefreshInvoice}
                />
              )}
            </div>
          </>
        )}
        <ConfirmPopup
          isOpen={openPopup}
          title="Delete Invoice"
          message="Do you want to delete this invoice?"
          onConfirm={handleDelete}
          onCancel={() => setOpenPopup(false)}
        />

        <ConfirmPopup
          isOpen={showUnmergeConfirm}
          title="Unmerge Invoice"
          message="Are you sure you want to unmerge this invoice? The original invoices will be restored."
          onConfirm={handleUnmergeConfirm}
          onCancel={handleUnmergeCancel}
        />
      </div>
    </div>
  );
};
export default ReviewInvoiceView;
